import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { DISTRIBUTION_EFFICIENCY_STATISTICS_GET } from 'api/query-keys';
import type { TGetDistributionEfficiencyStatisticsRes } from 'api/swagger';
import type { IDistributionEfficiencyFilter } from 'shared/stores/use-distribution-efficiency-filters';
import { setFiltersToQs } from 'shared/utils/filters/set-filters-to-qs';

interface IParams {
  filters: IDistributionEfficiencyFilter;
}

export const useGetDistributionEfficiencyStatistics = ({ filters }: IParams) => {
  const qs = new URLSearchParams();
  setFiltersToQs<IDistributionEfficiencyFilter>(qs, filters);

  return useQuery({
    queryKey: [DISTRIBUTION_EFFICIENCY_STATISTICS_GET, { filters }],
    queryFn: async () => {
      const { data } = await http.get<TGetDistributionEfficiencyStatisticsRes>(
        `/v1/statistics/cargo-time-in-days?${qs.toString()}`,
      );
      return data;
    },
    enabled: Boolean(filters.warehouseId),
    retry: false,
    refetchOnWindowFocus: false,
  });
};
